import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix PHP icon. Exported from Figma (Bombiix 2026). */
const PHPIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M6.66699 15.334V11.334M6.66699 11.334C6.66699 11.334 8.33366 11.334 9.00033 11.334C9.66699 11.334 12.667 11.3752 12.667 8.33401C12.667 5.29282 9.66699 5.33401 9.00033 5.33401C7.82875 5.33401 6.66699 5.33401 6.66699 5.33401V11.334ZM4.66699 7.33401H14.667M4.66699 9.33401H14.667"
      stroke="currentColor"
    />
  </svg>
);

export default PHPIcon;
